import { alert } from '../../../components/Alert/tokens/bluestone';
import { backDrop } from '../../../components/BackDrop/tokens/bluestone';
import { badge } from '../../../components/Badge/tokens/bluestone';
import { button } from '../../../components/Button/tokens/bluestone';
import { card } from '../../../components/Card/tokens/bluestone';
import { coupon } from '../../../components/Coupon/tokens/cobalt';
import { input } from '../../../components/Input/tokens/bluestone';
import { link } from '../../../components/Link/tokens/bluestone';
import { modal } from '../../../components/Modal/tokens/bluestone';
import { popup } from '../../../components/Popup/tokens/bluestone';
import { radioButton } from '../../../components/RadioButton/tokens/bluestone';
import { switchTokens } from '../../../components/Switch/tokens/bluestone';
import { link as deprecatedLink } from '../../../deprecated/Link/tokens/bluestone';
import { deprecatedModal } from '../../../deprecated/Modal/tokens/bluestone';
import { body } from '../../../typography/Body/tokens/bluestone';
import { display } from '../../../typography/Display/tokens/bluestone';
import { heading } from '../../../typography/Heading/tokens/bluestone';
import type { BaseComponentTokens } from '../types';
import { money } from '../../../components/Money/tokens/bluestone';

export const baseComponents: BaseComponentTokens = {
  alert,
  badge,
  backDrop,
  body,
  button,
  card,
  deprecatedLink,
  deprecatedModal,
  display,
  heading,
  input,
  link,
  modal,
  money,
  popup,
  radioButton,
  coupon,
  switch: switchTokens,
};
